import { AxiosResponse } from "axios";
import apiRequest from "../../utils/apiUtils/apiRequest";

interface VoucherGroupInterface {
  id: string;
  partnerName: string;
  allocatedVouchers: number;
  availableVouchers?: number;
  usedVouchers?: number;
  vouchers?: VoucherInterface[];
}

interface VoucherInterface {
  id: number;
  voucherCode: string;
  firstName: string;
  lastName: string;
  email: string;
  requestDate: Date;
  expirationDate: Date;
  status: string;
}

export async function getAllVouchersGroups(): Promise<AxiosResponse | Error> {
  const url = "/vouchergroups/all";
  return apiRequest.get(url).then((response: AxiosResponse) => {
    return response;
  });
}

export async function getVoucherGroup(id: string) {
  const url = `/vouchergroup/${id}`;
  return apiRequest
    .get(url)
    .then((response: AxiosResponse) => {
      return response;
    })
    .catch((error) => error);
}

export async function createVoucherGroup(voucherGroup: VoucherGroupInterface) {
  const url = `/vouchergroup/create`;
  return apiRequest.post(url, voucherGroup).then((response) => {
    return response;
  });
}
export async function userCreateVoucherGroup(
  voucherGroup: VoucherGroupInterface
) {
  const url = `/vouchergroup/create`;
  return apiRequest.post(url, voucherGroup).then((response) => {
    return response;
  });
}

export async function createVoucher(
  voucher: VoucherInterface,
  voucherGroupId: string
): Promise<AxiosResponse | Error> {
  const url = "/voucher/create/" + voucherGroupId;
  try {
    const response = await apiRequest.post(url, voucher);
    return response;
  } catch (error) {
    return error as Error;
  }
}
export function userCreateVoucher(
  voucher: VoucherInterface,
  voucherGroupId: string
): Promise<AxiosResponse | Error> {
  const url = "/user/voucher/create/" + voucherGroupId;
  return apiRequest.post(url, voucher).then((response: AxiosResponse) => {
    return response;
  });
}

export function updateVoucherGroup(
  voucherGroup: VoucherGroupInterface,
  voucherGroupId: string
): Promise<AxiosResponse | Error> {
  const url = "/vouchergroup/update" + voucherGroupId;
  return apiRequest.put(url, voucherGroup).then((response: AxiosResponse) => {
    return response;
  });
}

export function updateVoucher(voucher: VoucherInterface, voucherId: number) {
  const url = "/voucher/update/" + voucherId;
  return apiRequest.put(url, voucher).then((response: AxiosResponse) => {
    return response;
  });
}

export function deleteVoucher(voucherGroupId: string, voucherId: number) {
  const url = `/voucher/delete/${voucherGroupId}/${voucherId}`;
  return apiRequest.delete(url).then((response: AxiosResponse) => {
    return response;
  });
}
export function userDeleteVoucher(voucherGroupId: string, voucherId: number) {
  const url = `/user/voucher/delete/${voucherGroupId}/${voucherId}`;
  return apiRequest.delete(url).then((response: AxiosResponse) => {
    return response;
  });
}
